import { ComponentProps } from 'react';
import dynamic from 'next/dynamic';

import { Switch as SpSwitch } from './index.js';

export const Switch = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpSwitch,
        ComponentProps<typeof SpSwitch>
    >
>(() => import('./index.js').then(({ Switch }) => Switch), { ssr: false });
